import { useContext } from "react";
import { ErrorBannerContext } from "./ErrorBannerProvider";

export function useErrorBanner() {
  return useContext(ErrorBannerContext);
}
